import {
  GET_CIVILPROGRESSION,
  GET_CIVILPROGRESSION_SUCCESS,
  GET_CIVILPROGRESSION_FAIL,
  DELETE_CIVILPROGRESSION,
  DELETE_CIVILPROGRESSION_SUCCESS,
  DELETE_CIVILPROGRESSION_FAIL,
  UPDATE_CIVILPROGRESSION,
  UPDATE_CIVILPROGRESSION_SUCCESS,
  UPDATE_CIVILPROGRESSION_FAIL,
  ADD_NEW_CIVILPROGRESSION,
  ADD_CIVILPROGRESSION_SUCCESS,
  ADD_CIVILPROGRESSION_FAIL,
  CIVILPROGRESSION_LOADING,
  CIVILPROGRESSION_RESET
} from "./actionType";

export const resetCivilProgressionState = (actionType) => ({
  type: CIVILPROGRESSION_RESET,
  payload: { actionType },
});

export const getCivilProgressionSuccess = (actionType, data) => ({
  type: GET_CIVILPROGRESSION_SUCCESS,
  payload: { actionType, data },
});

export const getCivilProgressionFail = (actionType, error) => ({
  type: GET_CIVILPROGRESSION_FAIL,
  payload: { actionType, error },
});

export const getCivilProgression = data => ({
  type: GET_CIVILPROGRESSION,
  payload: data,
});

export const getCivilProgressionLoading = () => ({
  type: CIVILPROGRESSION_LOADING
});

export const deleteCivilProgression = data => ({
  type: DELETE_CIVILPROGRESSION,
  payload: data,
});

export const deleteCivilProgressionSuccess = data => ({
  type: DELETE_CIVILPROGRESSION_SUCCESS,
  payload: data,
});

export const deleteCivilProgressionFail = error => ({
  type: DELETE_CIVILPROGRESSION_FAIL,
  payload: error,
});

export const updateCivilProgression = data => ({
  type: UPDATE_CIVILPROGRESSION,
  payload: data,
});

export const updateCivilProgressionFail = error => ({
  type: UPDATE_CIVILPROGRESSION_FAIL,
  payload: error,
});

export const updateCivilProgressionSuccess = data => ({
  type: UPDATE_CIVILPROGRESSION_SUCCESS,
  payload: data,
});

export const addNewCivilProgression = data => ({
  type: ADD_NEW_CIVILPROGRESSION,
  payload: data,
});

export const addCivilProgressionSuccess = data => ({
  type: ADD_CIVILPROGRESSION_SUCCESS,
  payload: data,
});

export const addCivilProgressionFail = error => ({
  type: ADD_CIVILPROGRESSION_FAIL,
  payload: error,
});